module.exports = __webpack_public_path__ + "img/icon_2_41.5d6e0669.png";